import React from 'react';

import { MDText } from 'i18n-react';

import { CameraIcon, IdIcon, PaperStackIcon } from '@motorway/mw-highway-code';

import { DOCUMENT_KINDS } from '../../../DocumentCapture.helpers';
import { ExampleDocuments } from '../../ExampleDocuments/ExampleDocuments';
import { EXAMPLE_DOCUMENTS } from '../../ExampleDocuments/ExampleDocuments.helpers';
import LocalTexts from '../../UploadDocuments.texts.json';

import styles from './UploadDocumentsVerification.scss';

const LocalT = new MDText(LocalTexts.uploadDocumentsVerification);

const Icon = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.stepIcon}>
    {children}
  </div>
);

export const UploadVerificationSteps = [
  {
    content: (
      <>
        <Icon>
          <IdIcon />
        </Icon>

        <p data-thc-style-override>
          {LocalT.translate('steps.snapYourDrivingLicence', {
            drivingLicence: <span className={styles.exampleDocLink}>
              <ExampleDocuments
                {
                  ...EXAMPLE_DOCUMENTS[
                DOCUMENT_KINDS.DRIVING_LICENCE as keyof typeof EXAMPLE_DOCUMENTS
                  ] as Record<string, unknown>
                }
                actionLink={LocalT.translate('steps.drivingLicence') as string}
                documentTitle={LocalT.translate('steps.drivingLicenceModalTitle') as string}
                modalDescription={LocalT.translate('steps.drivingLicenceModalDescription') as string}
              />
            </span>,
          })}
        </p>
      </>
    ),
    id: 1,
  },
  {
    content:
      <>
        <Icon>
          <CameraIcon filled={false} />
        </Icon>
        {LocalT.translate('steps.takeASelfie')}
      </>,
    id: 2,
  },
  {
    content: (
      <>
        <Icon>
          <PaperStackIcon />
        </Icon>
        <p data-thc-style-override>
          {LocalT.translate('steps.uploadYourV5', {
            v5: <span className={styles.exampleDocLink}>
              <ExampleDocuments
                {...EXAMPLE_DOCUMENTS[DOCUMENT_KINDS.V5 as keyof typeof EXAMPLE_DOCUMENTS] as Record<string, unknown>}
                actionLink={LocalT.translate('steps.v5c') as string}
                documentTitle={LocalT.translate('steps.v5c') as string}
                modalDescription={LocalT.translate('steps.v5cModalDescription') as string}
              />
            </span>,
          })}
        </p>
      </>
    ),
    id: 3,
  },
];
